<template>
  <div class="ns-appointment__doctor-card smd-panel">
    <div class="ns-appointment__doctor-card-inner">
      <smd-profile-img size="m"
                       v-if="appointment"
                       :image="profileUrl"/>
      <div class="ns-appointment__details">
        <div class="ns-appointment__doctor-details">
          <h3 class="Title3">
            {{ appointment.doctorname }}
          </h3>
          <p class="Body3">{{ mainSpecialty }}</p>
        </div>
        <div class="ns-appointment__date-time">
          <div class="consultation-type">
            <p class="consultation-type-icon" :class="typeOfConsultClass"></p>
            <p class="m-l-5">{{ typeOfConsultText }}</p>
          </div>
          <p class="consultation-date">
            <span v-html="formattedAppointmentDate"></span>
          </p>
        </div>
        <div>
          <p class="ns-appointment__patient-name m-t-10"
             :class="{'Title3':appointment.type === 'NOW' }">
            {{ formattedPatientName }}
          </p>
        </div>
      </div>
      <div>
        <span class="ns-appointment__icon" :class="appointmentStatusIcon"/>
      </div>
    </div>
    <div class="smd-form__row justify-content-center m-t-15">
      <smd-btn v-if="toBePayedStatus" section="4"
               variant="red-enabled"
               @click.prevent.stop="payNow">
        Pay Now
      </smd-btn>
    </div>
  </div>
</template>

<script>
  import appointmentDetailsMixin from '@/mixins/appointment-details';
  import {ONDEMAND_STATUSES} from '@/reference/ondemand';
  import {isCampaignOnDemandVideo} from '@leapfroggr/patientappcommons/dist/modules/on-demand';

  import {
    AppointmentStatusWithToken,
  } from '@/constants';

  export default {
    name: 'appointments-doctor-card',
    mixins: [
      appointmentDetailsMixin,
    ],
    props: {
      appointment: {type: Object, required: false},
    },
    computed: {
      toBePayedStatus() {
        if (isCampaignOnDemandVideo(this.appointment.campaignid)) {
          return this.appointment.status === ONDEMAND_STATUSES.PAYMENT;
        }

        return this.appointment.status === AppointmentStatusWithToken.Payment;
      },
    },
    methods: {
      payNow() {
        window.open(this.appointment.billurl, '_blank');
      },
    },
  }
</script>

<style lang="scss">
  .ns-appointment__doctor-card {
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: space(m);
    }

    .ns-appointment__doctor-card-inner {
      @include make-grid-cols(65px 1fr 30px);
      position: relative;
    }

    .ns-appointment__details {
      flex-direction: column;
    }

    .ns-appointment__doctor-details {
      flex-direction: column;
      @include space-me($prop: margin, $b: s);

      .specialization {
        font-size: 13px;
      }
    }

    .ns-appointment__date-time {
      display: flex;
      flex-direction: column;
      font-size: 13px;

      .consultation-type {
        @include font-style(Body3);
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: space(s);

        &-icon {
          @include space-me($prop: margin, $r: xs);
          color: color(gray, text);
          font-size: 18px;
        }

        .text {
          color: color(label, text);
        }
      }

      .consultation-date {
        @include font-style(Body3);

        .date {
          @include font-style(Body5);
        }

        .time {
          text-transform: lowercase;
        }
      }
    }

    .ns-appointment__patient-name {
      @include font-style(Body3);
      padding: space(xs) space(m);
      display: inline-block;
      background-color: color(gray-50);
      border-radius: 22px;
    }

    .ns-appointment__icon {
      font-size: 20px;
      position: absolute;
      top: -8px;
      right: -8px;
    }

    .ns-appointment__icon {


      &-cancelled {
        color: color(red, tags);
      }

      &-confirmed {
        color: color(dodgerBlue);
      }

      &-completed {
        color: color(green, tags);
      }

      &-denied {
        color: color(purple, tags);
      }

      &-pending {
        color: color(yellow, tags);
      }

      &-skipped {
        color: color(base, tags);
      }

    }
  }
</style>